import React, { useState, useEffect } from 'react';
import './AdminLogin.css';
import { motion, AnimatePresence } from 'framer-motion';
import { FaLock, FaEnvelope, FaChevronRight, FaArrowLeft } from 'react-icons/fa';
import toast from 'react-hot-toast';
import logo from '../assets/logo.png';

import { safeFetch } from '../utils/apiUtils';

const AdminLogin = () => {
    useEffect(() => {
        const token = localStorage.getItem('admin_token');
        if (token) {
            window.location.href = '/admin/dashboard';
        }
    }, []);

    const [isForgotStep, setIsForgotStep] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const { ok, data } = await safeFetch('https://aayushrealproperties.in/nimaibackend/public/api/admin/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    password: password,
                }),
            });

            if (ok) {
                // Store Access token, ID, and Name
                localStorage.setItem('admin_token', data.access_token);
                localStorage.setItem('admin_id', data.admin.id);
                localStorage.setItem('admin_name', data.admin.name);

                toast.success('Successfully logged in!');
                setTimeout(() => {
                    window.location.href = '/admin/dashboard';
                }, 1000);
            } else {
                toast.error(data.message || 'Invalid credentials. Please try again.');
            }
        } catch (error) {
            console.error('Login error:', error);
            toast.error('Connection error. Please check if the backend is running.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleForgotSubmit = (e) => {
        e.preventDefault();
        toast.success('Password reset link sent to your email.');
        setTimeout(() => setIsForgotStep(false), 2000);
    };

    return (
        <div className="admin-login-page">
            <div className="admin-login-bg">
                <div className="blob blob-1"></div>
                <div className="blob blob-2"></div>
            </div>

            <motion.div
                className="login-container"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8 }}
            >
                <div className="login-card-glass">
                    <div className="login-header">
                        <img src={logo} alt="Logo" className="login-logo" />
                        <h2>Admin <span>Portal</span></h2>
                        <p>{isForgotStep ? "Reset your security credentials" : "Welcome back, please sign in."}</p>
                    </div>

                    <AnimatePresence mode="wait">
                        {!isForgotStep ? (
                            <motion.form
                                key="login"
                                className="login-form"
                                initial={{ opacity: 0, x: -20 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: 20 }}
                                onSubmit={handleLogin}
                            >
                                <div className="input-group">
                                    <FaEnvelope className="input-icon" />
                                    <input
                                        type="email"
                                        placeholder="Email Address"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="input-group">
                                    <FaLock className="input-icon" />
                                    <input
                                        type="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="form-options">
                                    <span
                                        className="forgot-link"
                                        onClick={() => setIsForgotStep(true)}
                                    >
                                        Forgot Password?
                                    </span>
                                </div>

                                <button type="submit" className="login-btn" disabled={isLoading}>
                                    {isLoading ? 'Signing In...' : 'Sign In'} <FaChevronRight />
                                </button>
                            </motion.form>
                        ) : (
                            <motion.form
                                key="forgot"
                                className="login-form"
                                initial={{ opacity: 0, x: 20 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 0, x: -20 }}
                                onSubmit={handleForgotSubmit}
                            >
                                <div className="input-group">
                                    <FaEnvelope className="input-icon" />
                                    <input
                                        type="email"
                                        placeholder="Registered Email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                </div>

                                <button type="submit" className="login-btn">
                                    Send Reset Link <FaChevronRight />
                                </button>

                                <button
                                    type="button"
                                    className="back-btn"
                                    onClick={() => setIsForgotStep(false)}
                                >
                                    <FaArrowLeft /> Back to Login
                                </button>
                            </motion.form>
                        )}
                    </AnimatePresence>
                </div>
                <p className="login-footer">© 2026 Nimai Solutions. Systems Protected.</p>
            </motion.div>
        </div>
    );
};

export default AdminLogin;
